import React from 'react'

import clsx from 'clsx'

import Avatar from 'components/Avatar'
import Icon from 'components/Icon'

import classes from './Avatars.module.scss'

/** @type {import("./types").default} */
const Avatars = ({ imagesUrl, imageSize, className }) => {
  return (
    <div className={clsx(classes.root, className)}>
      {imagesUrl.map((url, i) => (
        <Avatar
          key={`avatar-${i}`}
          src={url && `${url}?w=${imageSize}`}
          className={classes.avatar}
          alt={'Verified reviewer profile picture'}
        >
          <Icon icon={['fas', 'circle-user']} size="32" />
        </Avatar>
      ))}
    </div>
  )
}

export default Avatars
